module.exports = __webpack_public_path__ + "img/1460682871.27432adc.jpg";